// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9916bb5bb1d236ec31a0","655":"ee658e0e239a0e43fe8d"}[chunkId] + ".js";
};